export function formatNumber(n: number, digits = 1): string {
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString(undefined, {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  });
}

export function formatWithUnit(n: number, unit: string, digits = 1): string {
  return `${formatNumber(n, digits)} ${unit}`;
}
